module.exports = __webpack_public_path__ + "img/sh.6560d76b.svg";